var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppTabs",class:{
		'justify-content-around': _vm.tabs.length === 2,
		'justify-content-between': _vm.tabs.length === 3,
	}},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,attrs:{"to":{
			path: tab.to,
		}}},[_c('button',{staticClass:"AppTabs__action",class:{
				'AppTabs__action--active': _vm.$route.name === tab.to
			}},[(tab.name === 'Orders' && _vm.newOrder.products.length)?_c('span',{staticClass:"bouncing-circle"}):_vm._e(),_c('keep-alive',[_c(tab.icon,{tag:"component"})],1),_c('span',[_vm._v(_vm._s(tab.name))])],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }